import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ManageRolesForUsersContent from '../components/pages/meeting-room/manage-users/manageRolesModal';

function MeetingRoomManageUsersRolesModal(props) {
  const dispatch = useDispatch();

  const manageRolesSelectedUserId = useSelector((state) => state.meetingRoomReducer.manageUsersPage.selectedUserId);
  const rolesForSelectedUser = useSelector((state) => state.meetingRoomReducer.manageUsersPage.rolesForSelectedUser);

  return (
    <div>
      <ManageRolesForUsersContent
        selectedMeetingRoom={props.selectedMeetingRoom}
        availableRoles={props.availableRoles}
        usersIcanManage={props.usersIcanManage}
        manageRolesSelectedUserId={manageRolesSelectedUserId}
        rolesForSelectedUser={rolesForSelectedUser}
        dispatch={dispatch}
      />
    </div>
  );
}

export default MeetingRoomManageUsersRolesModal;
